import React from 'react';
import { Box, IconButton } from '@mui/material';
import { observer } from 'mobx-react-lite';

import InfoIcon from '@mui/icons-material/Info';

import {
  DataGrid,
  deDE,
  GridColDef,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';

import { ProfileData } from '../../store/UserStore';

const UserTable = observer(
  ({
    users,
    onRowClick,
    onInfoClick,
  }: {
    users: ProfileData[];
    onRowClick: (data: ProfileData) => void;
    onInfoClick: () => void;
  }): JSX.Element => {
    const usersWithIndex = users.map((user, index) => ({
      ...user,
      index: index + 1,
      points: user.pointsStore.groupPoints,
    }));

    const userColumns: GridColDef[] = [
      {
        field: 'index',
        headerName: 'Nr.',
        width: 50,
        editable: false,
        align: 'center',
      },

      {
        field: 'info',
        headerName: 'Info',
        width: 50,
        align: 'center',
        sortable: false,
        renderCell: () => (
          <Box style={{ margin: 'auto' }}>
            <IconButton onClick={onInfoClick}>
              <InfoIcon />
            </IconButton>
          </Box>
        ),
      },
      {
        field: 'shareToken',
        headerName: 'Share Code',
        width: 120,
        editable: false,
        align: 'center',
      },
      {
        field: 'firstName',
        headerName: 'Vorname',
        width: 150,
        editable: false,
      },
      {
        field: 'lastName',
        headerName: 'Nachname',
        width: 150,
        editable: false,
      },
      {
        field: 'companyName',
        headerName: 'Firma',
        width: 130,
        editable: false,
      },
      {
        field: 'points',
        headerName: 'Gesamtpunkte',
        width: 110,
        editable: false,
        align: 'center',
      },
    ];

    return (
      <Box style={{ height: 800, minWidth: 800, padding: '0 10px' }}>
        <DataGrid
          onCellClick={params => {
            onRowClick(params.row as ProfileData);
          }}
          getRowId={row => row.userId}
          localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
          components={{
            Toolbar: () => (
              <GridToolbarContainer sx={{ justifyContent: 'flex-end' }}>
                <GridToolbarQuickFilter />
              </GridToolbarContainer>
            ),
          }}
          checkboxSelection={false}
          rows={usersWithIndex || []}
          columns={userColumns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 100,
              },
            },
          }}
          pageSizeOptions={[10]}
          disableRowSelectionOnClick
        />
      </Box>
    );
  },
);

export default UserTable;
